import React from 'react'
import CKEditor from "ckeditor4-react-advanced"

const HotelForm = (props) => {
    return (
        <form>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Name</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="name" value={props.name} onChange={props.onChange} />
                        <span className="error">{props.errors.name}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Type</label>
                    </div>
                    <div className="form-input">
                        <select
                            name="type"
                            value={props.type}
                            onChange={(e) => props.onChange({
                                target: {
                                    name: "type",
                                    value: Number(e.target.value)
                                }
                            })}
                        >
                            <option value={0}>Hotel</option>
                            <option value={1}>Apartment</option>
                        </select>
                        <span className="error">{props.errors.type}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Status</label>
                    </div>
                    <div className="form-input">
                        <select
                            name="status"
                            value={props.status}
                            onChange={(e) => props.onChange({
                                target: {
                                    name: "status",
                                    value: Number(e.target.value)
                                }
                            })}
                        >
                            <option value={0}>Draft</option>
                            <option value={1}>Published</option>
                            <option value={2}>Archived</option>
                        </select>
                        <span className="error">{props.errors.status}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Address</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="address" value={props.address} onChange={props.onChange} />
                        <span className="error">{props.errors.address}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>City</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="city" value={props.city} onChange={props.onChange} />
                        <span className="error">{props.errors.city}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Country</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="country" value={props.country} onChange={props.onChange} />
                        <span className="error">{props.errors.country}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Stars</label>
                    </div>
                    <div className="form-input">
                        <input type="number" name="stars" value={props.stars} onChange={props.onChange} />
                        <span className="error">{props.errors.stars}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Price</label>
                    </div>
                    <div className="form-input">
                        <input type="number" name="price" value={props.price} onChange={props.onChange} />
                        <span className="error">{props.errors.price}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Features</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="features" value={props.features || ""} onChange={props.onChange} />
                        <span className="error">{props.errors.features}</span>
                    </div>
                </div>
                {props.children}
                <div className="row editor">
                    <div className="form-label">
                        <label>Description</label>
                    </div>
                    <CKEditor key={props.keyDescription}
                        data={props.description}
                        config={{
                            width: "100%",
                            versionCheck: false
                        }}
                        onChange={(event) => {
                            const data = event.editor.getData()
                            props.onChange({
                                target: {
                                    name: "description",
                                    value: data
                                }
                            })
                        }}
                    />
                    <span className="error">{props.errors.description}</span>
                </div>
            </div>
            <div className="actions">
                <button type="submit" onClick={props.onSubmit}>{props.action}</button>
                <button type="reset" onClick={props.onCancel}>Cancel</button>
            </div>
        </form>
    )
}

export default HotelForm
